import { getPageType } from '~/events/utils/pageType'
import productTransformer from './transformers/product.transformer'

export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.CART.ITEM.ADD, ({ addedAmount, item }) => {
    if (!item || !item.shoppable || !item.product) {
      return
    }

    const transformedProduct = productTransformer(
      item.product,
      addedAmount,
      item.prices?.unitWithoutTax,
      item.prices?.unitWithTax,
      0,
      null,
      item.attributes?.custom?.colour ?? null,
      item.attributes?.custom?.master_item_id ?? null,
    )

    if (!transformedProduct) {
      return
    }

    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: item.prices?.currencyCode || 'CZK',
        value: transformedProduct.price * transformedProduct.quantity,
        value_vat: transformedProduct.price_vat * transformedProduct.quantity,
        mkt_val_all: transformedProduct.price * transformedProduct.quantity,
        items: [transformedProduct],
        google_tag_params: {
          ecomm_pagetype: getPageType(),
          ecomm_prodid: [String(transformedProduct.item_id)],
          ecomm_totalvalue: transformedProduct.price * transformedProduct.quantity,
          ecomm_totalvalue_all: [transformedProduct.price * transformedProduct.quantity],
        },
      },
    })
  })
}
